import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';
import type { Facet } from '../@types/ElasticSearchResponse';
import type { BaseAction } from '../@types/actions';

export const REQ_OPEN_FOLDOUT = 'REQ/OPEN_FOLDOUT';
export const REQ_CLOSE_FOLDOUT = 'REQ/CLOSE_FOLDOUT';
type REQ_OPEN_FOLDOUT_TYPE = BaseAction<typeof REQ_OPEN_FOLDOUT> & {
  offset: number;
};
type REQ_CLOSE_FOLDOUT_TYPE = BaseAction<typeof REQ_CLOSE_FOLDOUT>;

export const REQ_OPEN_FILTER = 'REQ/OPEN_FILTER';
export const REQ_CLOSE_FILTER = 'REQ/CLOSE_FILTER';
type REQ_OPEN_FILTER_TYPE = BaseAction<typeof REQ_OPEN_FILTER> & {
  facet: Facet;
  offset: number;
  isExcludedFacet: boolean;
};
type REQ_CLOSE_FILTER_TYPE = BaseAction<typeof REQ_CLOSE_FILTER>;

export const REQ_SHOW_FILTER_BAR = 'REQ/SHOW_FILTER_BAR';
export const REQ_HIDE_FILTER_BAR = 'REQ/HIDE_FILTER_BAR';
type REQ_SHOW_FILTER_BAR_TYPE = BaseAction<typeof REQ_SHOW_FILTER_BAR>;
type REQ_HIDE_FILTER_BAR_TYPE = BaseAction<typeof REQ_HIDE_FILTER_BAR>;

export type FILTERS_ACTION =
  | REQ_OPEN_FOLDOUT_TYPE
  | REQ_CLOSE_FOLDOUT_TYPE
  | REQ_OPEN_FILTER_TYPE
  | REQ_CLOSE_FILTER_TYPE
  | REQ_SHOW_FILTER_BAR_TYPE
  | REQ_HIDE_FILTER_BAR_TYPE;

type Dispatch = ReduxDispatch<FILTERS_ACTION>;

export const openFoldout = (offset: number) => (dispatch: Dispatch) =>
  dispatch({ type: REQ_OPEN_FOLDOUT, offset });

export const closeFoldout = () => (dispatch: Dispatch) => dispatch({ type: REQ_CLOSE_FOLDOUT });

export const openFilter =
  (facet: Facet, offset: number, isExcludedFacet: boolean) => (dispatch: Dispatch) =>
    dispatch({ type: REQ_OPEN_FILTER, facet, offset, isExcludedFacet });

export const closeFilter = () => (dispatch: Dispatch) => dispatch({ type: REQ_CLOSE_FILTER });

export const showFilterBar = () => (dispatch: Dispatch) => dispatch({ type: REQ_SHOW_FILTER_BAR });
export const hideFilterBar = () => (dispatch: Dispatch) => dispatch({ type: REQ_HIDE_FILTER_BAR });
